import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  suggest() {
    const input = this.element.form.querySelector("input[name='price']")
    input.value = this.element.selectedOptions[0]?.dataset.price || ""
  }
}
